import axios from 'axios';

export function findArticles(searchParams) {
    let queryString = '?ignoreFilter=true';

    if (searchParams) {
        queryString += '&'
        queryString += Object.keys(searchParams || {})
            .map(key => key + '=' + searchParams[key])
            .join('&');
    }

    return axios.get('/articles/search' + queryString.toString());
}

export default function getArticles() {
    return axios.get('/articles');
}